@if (user) {
<mat-card [matMenuTriggerFor]="settingsMenu">
  <mat-card-content>
    <div class="avatar-and-name">
      <div class="avatar-wrapper">
        <app-avatar [src]="user.profilePictureUrl" [fullName]="user.fullName" width="40" height="40"></app-avatar>
        @if (unreadCount() > 0) {
        <span class="unread-dot" role="img" aria-label="Unread notifications"></span>
        }
      </div>
      <div class="user-info">
        <h5>{{ user.fullName }}</h5>
        <span>{{ userRole }}</span>
      </div>
      <img class="dropdown-button" src="/assets/icons/chevron-down.svg" />
    </div>
  </mat-card-content>
</mat-card>
}
<mat-menu #settingsMenu>
  <a mat-menu-item routerLink="/notifications">
    {{ 'navbar.notifications' | translate }}
    @if (unreadCount() > 0) {
    <span class="unread-count">{{ unreadCount() }}</span>
    }
  </a>
  <menu mat-menu-item [appLoading]="isReloading" (click)="reloadApp()">{{ 'navbar.reload' | translate }}</menu>
  <menu mat-menu-item [appLoading]="isLoggingOut" (click)="logout()">{{ 'navbar.logout' | translate }}</menu>
</mat-menu>
